import React from "react";

interface TemplatePreviewProps {
  file?: string; // logo (base64)
  header?: string; // HTML
  footer?: string; // HTML
}

// Visualização do template no tamanho de uma página A4 (210mm x 297mm):
// logo no topo à esquerda, cabeçalho no topo à direita, rodapé no final centralizado.
const TemplatePreview: React.FC<TemplatePreviewProps> = ({
  file,
  header,
  footer,
}) => (
  <div
    className="template-preview"
    style={{
      width: "210mm",
      minHeight: "297mm",
      padding: "15mm",
      boxSizing: "border-box",
      background: "white",
      margin: "0 auto",
      position: "relative",
      boxShadow: "0 0 8px rgba(0,0,0,0.15)",
      fontSize: "12pt",
      color: "#000",
    }}
  >
    {/* Topo: logo (esquerda) + cabeçalho (direita) */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "10mm",
      }}
    >
      <div style={{ flexShrink: 0 }}>
        {file ? (
          <img
            src={file}
            alt="logo"
            style={{ maxHeight: "30mm", maxWidth: "70mm", objectFit: "contain" }}
          />
        ) : null}
      </div>
      <div
        style={{ textAlign: "right", flex: 1, minWidth: 0 }}
        dangerouslySetInnerHTML={{ __html: header || "" }}
      />
    </div>

    {/* Rodapé: final da página, centralizado */}
    <div
      style={{
        position: "absolute",
        left: "15mm",
        right: "15mm",
        bottom: "8mm",
        textAlign: "center",
      }}
      dangerouslySetInnerHTML={{ __html: footer || "" }}
    />
  </div>
);

export default TemplatePreview;
